import "../theme/Administracion.css";
import { AzureAD, AuthenticationState } from "react-aad-msal";
import { TableAdministracionProductos } from "../components/TableAdministracionProductos";
import { BtnGoBack } from "../components/Buttons/BtnGoBack";
import { useDynamicAuth } from "../context/AuthProviderContext"; // Importar el hook

export const AdminPageProductos = () => {
    const authProvider = useDynamicAuth(); // Usar el hook

  return (
    <AzureAD provider={authProvider}>
      {({ authenticationState, accountInfo }) => {
        const isAuthenticated = authenticationState === AuthenticationState.Authenticated;

        if (isAuthenticated) {
          return (
            <div className="body-color">
              <div className="title-name-admin">
                <BtnGoBack caption="Volver a administración" />
              </div>

              <TableAdministracionProductos />
            </div>
          );
        }
      }}
    </AzureAD>
  );
};
